import { axiosInstance } from '../../helpers/api_helper';

const updateStoreDetails = async (formData: any) => {
  try {
    console.log('FormData in updateStoreDetails:', formData);

    const response = await axiosInstance.patch(`/StoreDetails/UpdateStoreDetails`, formData);

    console.log('API Response from updateStoreDetails:', response); // Log the response

    if (response.data.ResponseCode === "00") {
      // Handle success, if needed
      return response.data;
    } else {
      // Handle error
      throw new Error('Error updating store details');
    }
  } catch (error:any) {
    // Handle network or other errors
    throw new Error(`Error: ${error.message}`);
  }
};

export { updateStoreDetails };
